import * as React from 'react'
import './styles.css'
// libs
import { motion } from 'motion/react'
import { useForm } from 'react-hook-form'
// components
import Input from '../../../../../../ui/Input/input'

const Form = ({ onSubmit, submitError }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm()

  return (
    <motion.div
      key='password'
      initial={{ opacity: 0 }}
      animate={{ opacity: 11 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.25 }}
      className='mwm-password-overlay'
    >
      <form onSubmit={handleSubmit(onSubmit)} className='mwm-password-form'>
        <div className='mwm-input-wrapper'>
          <Input
            id='password'
            type='password'
            label='Password'
            register={register}
            errors={errors}
            watch={watch}
          />
          {submitError && (
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className='error-message'
            >
              Incorrect password. Please try again.
            </motion.p>
          )}
          <button type='submit' className='mwm-submit-button'>
            Submit
          </button>
        </div>
      </form>
    </motion.div>
  )
}

export default Form
